export default __webpack_public_path__ + "static/media/manual-active.5870c860.svg";